import { z } from 'zod';

export const JSONStringSchema = z
  .string()
  .transform((str) => {
    JSON.parse(str);
    return str;
  })
  .brand<'JSONString'>();

export type JSONString = z.infer<typeof JSONStringSchema>;
